module.exports = __webpack_public_path__ + "img/rec2.83d26279.png";